<template>
    <div>
        <v-expansion-panels>
            <v-expansion-panel v-for="(mobility, competedLevel) in mobilityInformation" :key="competedLevel">
                <v-expansion-panel-header :class="{ blue: event === 'TI', green: event === 'DM', red: event === 'TU' }">
                    <div class="d-flex">
                        <div class="mr-2 mt-n1">
                            <span v-if="mobilityAchieved(competedLevel)">
                                <v-icon>mdi-check</v-icon>
                            </span>
                            <span v-else>
                                <v-icon>mdi-close</v-icon>
                            </span>
                        </div>
                        <div>
                            <span v-if="event === 'TI'">Trampoline&nbsp;</span>
                            <span v-else-if="event === 'DM'">Double Mini&nbsp;</span>
                            <span v-else-if="event === 'TU'">Tumbling&nbsp;</span>
                            <span>From&nbsp;</span>
                            <strong>{{ level(mobilityFor(competedLevel)?.level_from).label }}&nbsp;</strong>
                            <span>to&nbsp;</span>
                            <strong>{{ level(mobilityFor(competedLevel)?.level_to).label }}</strong>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-right mt-4 mb-n4">
                                Mobility Score:
                                <span v-if="mobilityFor(competedLevel)?.total_score">
                                    {{ numeral(mobilityFor(competedLevel)?.total_score).format('0.000') }}
                                </span>
                                <span v-else-if="mobilityFor(competedLevel)?.total_w_tof">
                                    {{ numeral(mobilityFor(competedLevel)?.total_w_tof).format('0.000') }} (with TOF)
                                </span>
                            </h2>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-list dense>
                                <v-list-item v-for="result in mobility.results" :key="result.meet.id">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ result.meet.name }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <strong>{{ result.meet.title_with_year }}</strong> -
                                            {{ $moment.utc(result.meet.start_date).format('MMM DD, YYYY') }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-chip :color="result.mobilized ? 'green' : 'red'">
                                            {{ numeral(result.prelims_score).format('0.000') }}
                                        </v-chip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-alert
                                :type="mobilityAchieved(competedLevel) ? 'success' : 'error'"
                                dense
                                text
                                border="left"
                            >
                                {{ mobilityAchieved(competedLevel) ? 'Mobility Achieved!' : 'Mobility Not Achieved' }}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import numeral from 'numeral';
import { level } from '@/helpers.js';

export default {
    name: 'AthleteMobilityEvent',

    props: {
        athleteId: {
            type: Number,
            required: true,
        },

        mobilityInformation: {
            type: Object,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },
    },

    methods: {
        level,
        numeral,

        mobilityFor(competedLevel) {
            if (this.mobilityInformation[competedLevel].mobilities.length === 0) {
                console.log('No mobility information for', competedLevel);
            }

            return this.mobilityInformation[competedLevel].mobilities[0];
        },

        mobilityAchieved(competedLevel) {
            return this.mobilityInformation[competedLevel].results.some(result => result.mobilized);
        },
    },
};
</script>
